/*
 * rewards.js — /pages/rewards controller (B2C-242, LoyaltyLion "Approach B").
 *
 * The LoyaltyLion SDK is loaded AND authenticated site-wide by the LL Shopify
 * app-embed; this file does NOT mount or init LL. It owns theme-side fixes over
 * LL's rendered DOM. Page-scoped classic IIFE, `defer`, exposes no global,
 * lifecycle-disciplined (CONSTITUTION §VI). Both fixes use capture-phase
 * delegation on `document` so they survive LL's async (re)renders.
 *
 * Fix #1 — Tab navigation under the sticky header.
 *   LL's nav tabs scroll their section to the very top of the viewport, hidden
 *   under Casinetto's sticky header (~132px). LL scrolls a different element per
 *   tab, so CSS `scroll-margin` alone is unreliable. We take control: intercept
 *   the click, map tab -> section, scroll to `top - live header height - gap`.
 *
 * Fix #2 — Guest splash "Join now" / "Log in" return-to.
 *   LL links those to shopify.com/<id>/account with no return path, stranding the
 *   user on the hosted account page. Redirect through the NCA login entry that
 *   returns to /pages/rewards (snippets/account-login-href.liquid, B2C-262),
 *   exposed on the root as data-rewards-login-href.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rewards-root]');
  if (!root) {
    return; // only on /pages/rewards
  }

  var GAP = 16; // breathing room below the sticky header
  var loginHref = root.getAttribute('data-rewards-login-href') || '';

  // --- Fix #1: tab scroll ---------------------------------------------------
  var NAV_TARGETS = {
    'lion-header__nav-link--available-rewards': '.lion-available-rewards',
    'lion-header__nav-link--earn': '.lion-earn',
    'lion-header__nav-link--redeem': '.lion-redeem',
    'lion-header__nav-link--account-history': '.lion-account-history',
    'lion-header__nav-link--faq': '.lion-faq'
  };

  function headerOffset() {
    var h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
    return (isNaN(h) ? 132 : h) + GAP;
  }

  function targetFor(link) {
    var keys = Object.keys(NAV_TARGETS);
    for (var i = 0; i < keys.length; i++) {
      if (link.classList.contains(keys[i])) {
        return document.querySelector('#loyaltylion ' + NAV_TARGETS[keys[i]]);
      }
    }
    return null;
  }

  function onNavClick(e) {
    var link = e.target.closest ? e.target.closest('.lion-header__nav-link') : null;
    if (!link || !root.contains(link)) {
      return;
    }
    var target = targetFor(link);
    if (!target) {
      return; // unknown tab — let LL handle it
    }
    e.preventDefault();
    e.stopPropagation();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  // --- Fix #2: guest auth return-to ----------------------------------------
  function onAuthClick(e) {
    if (!loginHref) {
      return;
    }
    var link = e.target.closest ? e.target.closest('#loyaltylion a.lion-action-button') : null;
    if (!link) {
      return;
    }
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/account') === -1) {
      return; // only the guest splash sign-in / join links point at /account
    }
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(loginHref);
  }

  document.addEventListener('click', onNavClick, true); // capture: beat LL's handler
  document.addEventListener('click', onAuthClick, true);

  window.addEventListener('pagehide', function () {
    document.removeEventListener('click', onNavClick, true);
    document.removeEventListener('click', onAuthClick, true);
  });
})();
